import { render, staticRenderFns } from "./view_approval.vue?vue&type=template&id=5994f128&scoped=true"
import script from "./view_approval.vue?vue&type=script&lang=js"
export * from "./view_approval.vue?vue&type=script&lang=js"
import style0 from "./view_approval.vue?vue&type=style&index=0&id=5994f128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5994f128",
  null
  
)

export default component.exports